import * as React from 'react';
import {CustomInput, Tooltip} from "reactstrap";
import sendMessageToPreview from "../utils/sendMessageToPreview";

function SurveyDarkMode() {
	const [tooltipOpen, setTooltipOpen] = React.useState(false);
	const toggleTooltipOpen = () => setTooltipOpen(!tooltipOpen);
	const search = window.location.search;
	const params = new URLSearchParams(search);
	const forceDarkMode = params.get('darkMode') ? params.get('darkMode') : params.get('darkmode');
	const [value, setValue] = React.useState(parseInt(localStorage.surveyDarkMode) === 1 || forceDarkMode ? 1 : 0);

	const enableDarkMode = () => {
		document.body.classList.add('dark-mode');
	}

	const disableDarkMode = () => {
		document.body.classList.remove('dark-mode');
	}

	if (value) {
		enableDarkMode();
	}

	return (
		<div id="darkModeSwitchTooltip">
			<CustomInput
				type="switch"
				id="darkModeSwitch"
				checked={value}
				onChange={e => {
					setValue(e.target.checked);
					localStorage.surveyDarkMode = e.target.checked ? 1 : 0;
					if (e.target.checked) {
						enableDarkMode();
					} else {
						disableDarkMode();
					}
					sendMessageToPreview();
				}}
			/>
			<Tooltip
				target={"darkModeSwitchTooltip"}
				isOpen={tooltipOpen}
				toggle={toggleTooltipOpen}
			>Tryb ciemny / Dark mode</Tooltip>
		</div>
	);
}

SurveyDarkMode.propTypes = {};

export default SurveyDarkMode;